import { render } from "./RecycleStaff.vue?vue&type=template&id=6b44af93"
import script from "./RecycleStaff.vue?vue&type=script&lang=js"
export * from "./RecycleStaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__